import { Button, useIsMobile } from '@brg/ui'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ErrorText, ErrorTitle, PaymentErrorOuterWrapper } from './styles'
import { getCurrentContextName } from 'supporting'
import { BrgButton } from 'shared/components/buttons'

interface CompetitionProjectSentProps {
    onClick?: () => void
    onClose?: () => void
}

const CompetitionProjectSent: FC<CompetitionProjectSentProps> = ({ onClick }) => {
    const { t } = useTranslation()
    const isMobile = useIsMobile()
    const contextName = getCurrentContextName();

    return <PaymentErrorOuterWrapper>
        <ErrorTitle mobile={isMobile}>{t("project_edit.project_sent_to_competition")}</ErrorTitle>
        <ErrorText mobile={isMobile}>{t("project_edit.project_sent_to_competition_description")}</ErrorText>
        <BrgButton onClick={onClick}>
            {t("project_edit.go_to_competition")}
        </BrgButton>
    </PaymentErrorOuterWrapper>
}

export default CompetitionProjectSent;import { Button, useIsMobile } from '@brg/ui'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ErrorText, ErrorTitle, PaymentErrorOuterWrapper } from './styles'
import { getCurrentContextName } from 'supporting'
import { BrgButton } from 'shared/components/buttons'

interface CompetitionProjectSentProps {
    onClick?: () => void
    onClose?: () => void
}

const CompetitionProjectSent: FC<CompetitionProjectSentProps> = ({ onClick }) => {
    const { t } = useTranslation()
    const isMobile = useIsMobile()
    const contextName = getCurrentContextName();

    return <PaymentErrorOuterWrapper>
        <ErrorTitle mobile={isMobile}>{t("project_edit.project_sent_to_competition")}</ErrorTitle>
        <ErrorText mobile={isMobile}>{t("project_edit.project_sent_to_competition_description")}</ErrorText>
        <BrgButton onClick={onClick}>
            {t("project_edit.go_to_competition")}
        </BrgButton>
    </PaymentErrorOuterWrapper>
}

export default CompetitionProjectSent;